<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="spacer-banner"></span>
  <button mat-icon-button (click)="closeDialogDetalleUsuario()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-title class="card-title">Consultando Usuario ({{userName}})</mat-card-title>
  <mat-card-content>
    <div class="mat-elevation-z4 div-ajusted div-full-width">
      <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.md="row"
          fxLayout.xs="column" class="divconten-padding-top">
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Nombre y Apellido:</mat-label>
              <input matInput formControlName="name" name="name" minlength="3" maxlength="20" [attr.colspan]="2"
                autocomplete="off" required>
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Perfil:</mat-label>
              <input matInput formControlName="profileName" name="profileName" minlength="5" maxlength="20"
                autocomplete="off">
              <mat-icon matSuffix>manage_accounts</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-padding-top">
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Número Teléfono Persona:</mat-label>
              <input matInput formControlName="phoneNumber" name="phoneNumber" minlength="10" maxlength="15"
                autocomplete="off">
              <mat-icon matSuffix>phone_enabled</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Correo Electrónico Persona:</mat-label>
              <input matInput formControlName="userEmail" name="userEmail" maxlength="50" autocomplete="off" required>
              <mat-icon matSuffix>alternate_email</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Estatus Usuario:</mat-label>
              <input matInput formControlName="isExpired" name="isExpired" minlength="5" maxlength="20"
                autocomplete="off">
              <mat-icon matSuffix>manage_accounts</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-padding-top">
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Razón Social:</mat-label>
              <input matInput formControlName="companyName" name="companyName" minlength="4" maxlength="50"
                autocomplete="off" required>
              <mat-icon matSuffix>apartment</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Número de RIF:</mat-label>
              <input matInput formControlName="rif" name="rif" maxlength="12" autocomplete="off" required>
              <mat-icon matSuffix>badge</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Número de Teléfono Empresa:</mat-label>
              <input matInput formControlName="phone" name="phone" minlength="10" maxlength="15" autocomplete="off"
                required>
              <mat-icon matSuffix>phone_enabled</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-padding-top">
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Correo Electrónico Empresa:</mat-label>
              <input matInput formControlName="companyEmail" name="companyEmail" maxlength="50" autocomplete="off">
              <mat-icon matSuffix>alternate_email</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Ciudad:</mat-label>
              <input matInput formControlName="fiscalAddress" name="fiscalAddress" minlength="4" maxlength="30"
                autocomplete="off" required>
              <mat-icon matSuffix>location_on</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Serial de Licencias</mat-label>
              <mat-select [(value)]="selectedLicense" formControlName="serialLicense">
                <mat-option [value]="option.id" *ngFor="let option of licenseEntities">{{ option.value }}</mat-option>
              </mat-select>
              <mat-icon matSuffix>vpn_key</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-padding-top">
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Fecha Inicio Licencia:</mat-label>
              <input matInput formControlName="initDate" name="initDate" maxlength="50" autocomplete="off">
              <mat-icon matSuffix>calendar_month</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Fecha Fin Licencia:</mat-label>
              <input matInput formControlName="endDate" name="endDate" minlength="4" maxlength="30" autocomplete="off"
                required>
              <mat-icon matSuffix>calendar_month</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Cantidad de Licencias:</mat-label>
              <input matInput formControlName="licensesNumber" name="licensesNumber" minlength="1" maxlength="5"
                autocomplete="off" required>
              <mat-icon matSuffix>pin</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
        class="divconten">
        <div fxLayout="column">
          <button mat-raised-button color="secondary" type="button" (click)="resetUser();"
            class="align-center-middle">
            <span class="text-icon-space">Reiniciar</span>
            <mat-icon>restart_alt</mat-icon>
          </button>
        </div>
        <div fxLayout="column">
          <button mat-raised-button color="warn" type="button" (click)="disableUser()"
            class="align-center-middle">
            <span class="text-icon-space">Eliminar</span>
            <mat-icon>person_off</mat-icon>
          </button>
        </div>
        <div fxLayout="column" *ngIf="editar" >
          <button mat-raised-button color="primary" type="button" (click)="habilitarCampos()" class="align-center-middle">
            <span class="text-icon-space">Editar</span>
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <div fxLayout="column" *ngIf="!editar" >
          <button mat-raised-button color="primary" type="summit" class="align-center-middle">
            <span class="text-icon-space">Guardar</span>
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
      </form>
    </div>
  </mat-card-content>

</mat-card>
